
import {tentativeCall} from '../../libs/function/tentativeCall.js';

export const valueListToArray = (val) => {
  if (typeof(val) == 'function')
    return valueListToArray(val());
  if (typeof(val) == 'object') {
    const res = [];
    for (let [k, v] of Object.entries(val)) {
      if (!tentativeCall(v))
        continue;
      for (const vr of valueListToArray(k))
        res.push(vr);
    }
    return res;
  }
  // `Array.isArray(value)` works for all known array detection cases.
  if (Array.isArray(val)) {
    const res = [];
    for (const v of val)
      for (const vr of valueListToArray(v))
        res.push(vr);
    return res;
  }
  return String(val).trim().split(/[ \t\r\n]+/sg).filter(v => !!v);
};
